import { A_PROPERTY_INFORMATION_VISITS } from "@/src-refactor/modules/shared/model/const/property/ information-visits.const";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyVisit = (
  data: IPropertyDetailsResponse
): string | null => {
  return (
    A_PROPERTY_INFORMATION_VISITS.find(item => item.id === data?.visit)?.name || null
  );
};
